export default "__VITE_ASSET__8f1f9de6__"